import { render, staticRenderFns } from "./PropertyStickybeakStats.vue?vue&type=template&id=0ca14418&"
import script from "./PropertyStickybeakStats.vue?vue&type=script&lang=ts&"
export * from "./PropertyStickybeakStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports